'use client'

import UIFlex from '@components/ui/UIFlex'
import { Box, styled } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import color from '@ui/style/color.theme'
import PollResultBar from './PollResultBar'
import {
	PollResultSetProps,
	computeAnswerList,
	getPercent,
	getTotal,
	getVote,
	remainPercent,
} from '.'

const ResultItemBox = styled(Box)(() => ({
	paddingTop: pxToRem(12),
	paddingBottom: pxToRem(12),
	'&:not(:last-child)': {
		borderBottom: `1px solid ${color.colGray3}`,
	},
}))

const PollResultBarSet = ({ poll, selected }: PollResultSetProps) => {
	const answerList = computeAnswerList(poll.answerList)
	const total = getTotal(answerList)

	return (
		<UIFlex px={pxToRem(16)} borderRadius={pxToRem(8)} bgcolor={color.colWhite}>
			<UIFlex>
				{answerList.map((answer, index) => (
					<ResultItemBox key={`answer-${answer.answerIdx}`}>
						<PollResultBar
							title={answer.answerContent}
							voted={getVote(answer.answerPollCnt)}
							isTop={
								answer.answerPollCnt ===
								Math.max(...answerList.map(({ answerPollCnt }) => answerPollCnt))
							}
							isUserVoted={
								answer.isUserSelect ||
								selected?.includes(answer.answerIdx.toString())
							}
							percent={
								answerList.length - 1 === index && total !== 0
									? remainPercent(answerList, total)
									: getPercent(answer.answerPollCnt, total)
							}
						/>
					</ResultItemBox>
				))}
			</UIFlex>
		</UIFlex>
	)
}

export default PollResultBarSet
